import styled, { css } from 'styled-components/macro'
import { badgeTypes } from 'constants/variables'

export const Container = styled.div<{ value: string }>`
  padding: 0.4rem 1.2rem;
  min-width: 5.6rem;
  height: 2.4rem;
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 0.4rem;
  background-color: ${(props) => props.theme.color.white};
  border-radius: 0.8rem;
  ${(props) =>
    badgeTypes.SUCCESS === props.value &&
    css`
      background-color: ${(props) => props.theme.color.success};
    `}
  ${(props) =>
    badgeTypes.PENDING === props.value &&
    css`
      background-color: ${(props) => props.theme.color.warning};
    `}
  ${(props) =>
    badgeTypes.FAIL === props.value &&
    css`
      background-color: ${(props) => props.theme.color.danger};
    `}
`

export const Text = styled.span<{ value: string }>`
  margin: 0;
  padding: 0;
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: ${(props) => props.theme.font.size.small};
  line-height: normal;
  color: ${(props) => props.theme.color.text};
  text-transform: capitalize;
  ${(props) =>
    badgeTypes.FAIL === props.value &&
    css`
      color: ${(props) => props.theme.color.textPrimary};
    `}
`
